import Link from 'next/link';
import { Dispatch, SetStateAction } from 'react';

import { IResolvedCrossSaleAction } from '@/src/utils/collections/cross-sale.mapper';
import { ILocaleType } from '@/src/types';

interface IProps {
  action: IResolvedCrossSaleAction;
  locale: ILocaleType;
  setIsExpanded: Dispatch<SetStateAction<boolean>>;
}

export const CrossSaleAction = ({ action, locale, setIsExpanded }: IProps) => {
  if (action.type === 'destinations') {
    return (
      <Link
        className={
          'min-w-28 cursor-pointer rounded-4xl bg-primary p-4 text-center font-bold text-white no-underline active:bg-primary-dark'
        }
        href={`/${locale.locale}/destinations`}
        onClick={() => {
          window.dataLayer?.push({
            event: 'click_button',
            click_id: `/${locale.locale}/destinations`,
            click_label: action.text,
          });
        }}
      >
        {action.text}
      </Link>
    );
  } else if (action.type === 'expand') {
    return (
      <button
        onClick={() => setIsExpanded(true)}
        className={
          'min-w-28 cursor-pointer rounded-4xl bg-primary p-4 font-bold text-white active:bg-primary-dark peer-has-[.show-more-toggle:checked]:hidden'
        }
      >
        {action.text}
      </button>
    );
  }
};
